import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, Renderer2, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';

import { StateService, AuthService, RemittanceService } from '../../../services';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { } from '../../../shared/modals';
import { AuctionLotSearchSortType } from 'src/app/models/auction-lot-search-sort-type';
import { AppConfig } from 'src/app/config';
import { fadeAnimation } from 'src/app/shared/animations';
import { RemittanceSummaryModel } from 'src/app/models';
import { ModalPayInvoiceComponent } from 'src/app/invoice/modals';

@Component({
    selector: 'page-remittance-detail',
    styleUrls: ['./page-remittance-detail.component.scss'],
    templateUrl: './page-remittance-detail.component.html',
    animations: [fadeAnimation],
})
export class PageRemittanceDetailComponent implements OnInit {
    processing: boolean = false;
    initialized: boolean = false;
    remittanceId: number;
    RemittanceDetail: RemittanceSummaryModel = new RemittanceSummaryModel();
    isBusy: boolean = false;
    sendingEmails: boolean = false;
    address: string;
    RemittancePayments: any[];
    AuctionId: number;
    Id: number;

    constructor(public router: Router,
        private appConfig: AppConfig,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public remittanceService: RemittanceService,
        public formFunctions: FormFunctions,
        private decimalPipe: DecimalPipe
    ) {
        var me = this;
        me.remittanceId = me.activatedRoute.snapshot.params.remittanceId;

        me.LoadData();
    }

    ngOnInit() {
        let me = this;
        // Wait until the default auction is loaded
    }

    LoadData() {
        let me = this;

        me.remittanceService.FindSummaryById(me.remittanceId).subscribe(data => {
            me.RemittanceDetail = data;
            me.RemittancePayments = me.RemittanceDetail.RemittancePayments;
            me.AuctionId = data.Remittance.AuctionId;
            me.Id = data.Remittance.Id;

            me.isBusy = false;
        });

    }

    Updated() {
        // console.log('Updated');
    }

    Cleared() {
        // console.log('Cleared');

    }

    GetTotals(totalOf) {
        let me = this;

        if (!me.RemittanceDetail || !me.RemittanceDetail.RemittanceItems) {
            return "$0.00";
        }

        let totHammer = me.RemittanceDetail.RemittanceItems.reduce((sum, item) => sum + item.TotalHammerInclGST, 0);
        let totPremium = me.RemittanceDetail.RemittanceItems.reduce((sum, item) => sum + item.PremiumIncGST, 0);
        let itemGst = me.RemittanceDetail.RemittanceItems.reduce((sum, item) => sum + item.GSTPremium, 0);
        let totPayments = me.RemittanceDetail.RemittancePayments.reduce((sum, item) => sum + item.Amount, 0);
        let totOtherCharges = me.RemittanceDetail.RemittanceAdjustments.reduce((sum, item) => sum + item.Amount, 0);
        let totOtherChargesGst = me.RemittanceDetail.RemittanceAdjustments.reduce((sum, item) => sum + item.GstAmount, 0);
        let net = totHammer - totPremium - totOtherCharges - totOtherChargesGst;
        let remitted = totPayments;
        let leftToRemitted = net - remitted;

        let totGst = itemGst + totOtherChargesGst;
        // debugger;
        if (totalOf == 'sales') {
            return '$' + this.decimalPipe.transform((totHammer), '1.2-2');
        } else if (totalOf == 'premium') {
            return '$' + this.decimalPipe.transform((totPremium), '1.2-2');
        } else if (totalOf == 'totalgst') {
            return '$' + this.decimalPipe.transform((totGst), '1.2-2');
        } else if (totalOf == 'net') {
            return '$' + this.decimalPipe.transform((net), '1.2-2');
        } else if (totalOf == 'remitted') {
            return '$' + this.decimalPipe.transform((remitted), '1.2-2');
        } else if (totalOf == 'lefttoremitted') {
            return '$' + this.decimalPipe.transform((leftToRemitted), '1.2-2');
        } else if (totalOf == 'adjustments') {
            return '$' + this.decimalPipe.transform((totOtherCharges), '1.2-2');
        }

        return "$0.00";
    }

    getAddress() {
        var me = this;

        let address = me.RemittanceDetail.Remittance.Vendor.AddressLine1;
        if (me.RemittanceDetail.Remittance.Vendor.AddressLine2 && me.RemittanceDetail.Remittance.Vendor.AddressLine2.trim() != "") {
            address = `${address}\n${me.RemittanceDetail.Remittance.Vendor.AddressLine2}`;
        }
        address = `${address}\n${me.RemittanceDetail.Remittance.Vendor.Suburb}`;
        address = `${address}\n${me.RemittanceDetail.Remittance.Vendor.State} ${me.RemittanceDetail.Remittance.Vendor.Postcode}`;

        return address;
    }

}
